/*
 * @Author: 肖玲
 * @Date: 2023-02-28 16:20:35
 * @LastEditTime: 2023-02-28 18:36:27
 * @LastEditors: 肖玲
 * @Description: 
 * @FilePath: \p2ps_vip_web\src\router\butterfly-flow-system\flow-direction-import\modules\noCleanflowDirectionRouter.js
 * 流向导入 无清洗
 */
const noCleanflowDirectionRouter = [
  // 销售数据导入（无清洗）
  {
    path: '/flowSystem/flow-new-import/:meta_type',
    name: 'flowSystemFlowNewImport',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemConfig8" */
      //   '@/views/flowSystem/FlowNewImport.vue'
      // ),   待删除文件
    import(
      /*webpackChunkName:"flowSystemConfig8" */
      '@/views/butterfly-flow-system/flow-direction-import/noclean-flow-direction-import/sales-data-import/Page.vue'
    ),     //新迁移文件
    meta: {
      SecondaryMenu: '流向导入(无清洗)', //二级菜单
      isMoreMeta: true,
      1: {
        title: '销售数据导入',
      },
      2: {
        title: '库存数据导入',
      },
      3: {
        title: '采购数据导入',
      },
    },
  },
]
export default noCleanflowDirectionRouter